import { render, staticRenderFns } from "./PartyBuilding.vue?vue&type=template&id=dd5bc9aa&scoped=true"
import script from "./PartyBuilding.vue?vue&type=script&lang=js"
export * from "./PartyBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5bc9aa",
  null
  
)

export default component.exports